import { Component, OnDestroy, OnInit } from '@angular/core';
import { InOutRetrievalService, Ecus } from 'src/app/services/apiHandler/i-o-retrieval/in-out-retrieval.service';
import { GlobalService } from 'src/app/services/helper/global-helper';

@Component({
  selector: 'app-in-out-overview',
  templateUrl: './in-out-overview.component.html',
  styleUrls: ['./in-out-overview.component.scss']
})
export class InOutOverviewComponent implements OnInit, OnDestroy {

  currentEcus = this.global.iOEcus; //[120,121,122] temporary array with ecuIds where pin query is available
  ecus: Ecus[] = [];

  constructor(private global: GlobalService, private ioService: InOutRetrievalService){}

  ngOnInit(): void {
    this.setupList().then(()=> {
      this.global.io.subscribe({
        next: newValue => {
          if(newValue.expanded_id != ''){
            let indexToUpdate = this.ecus.findIndex(item => item.id === newValue.expanded_id);
            this.ecus[indexToUpdate].expanded = true;
          }
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.global.io.next({expanded_id: ''});
  }

  private setupList(): Promise<void>{
    return new Promise((resolve) => {
      this.ioService.getPinLabels().subscribe((res)=> {
        let allEcus =  JSON.parse(JSON.stringify(res.body));
        for (const element of allEcus) {
          if(this.currentEcus.includes(element.ecu_id)){ // maybe in future obsolet as PinLabels only have possible ecus in future opposed to all as of currently
            this.ecus.push({
              'name': element.ecu_name + ' (' + element.ecu_id.toString() + ')', // name in format: name (ecuId)
              'id': element.ecu_id,
              'expanded': false
            });
          }
        }        
        resolve();
      });
    });
  }

}
